import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../api/client';

export const fetchUsers = createAsyncThunk('users/fetchAll', async () => {
  const { data } = await client.get('/auth/users/');
  return data.results || data;
});

export const createUser = createAsyncThunk('users/create', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await client.post('/auth/users/', payload);
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

export const updateUser = createAsyncThunk('users/update', async ({ id, ...payload }, { rejectWithValue }) => {
  try {
    const { data } = await client.patch(`/auth/users/${id}/`, payload);
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

export const deleteUser = createAsyncThunk('users/delete', async (id, { rejectWithValue }) => {
  try {
    await client.delete(`/auth/users/${id}/`);
    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

const usersSlice = createSlice({
  name: 'users',
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchUsers.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchUsers.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createUser.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateUser.fulfilled, (state, action) => {
        const idx = state.list.findIndex(u => u.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.list = state.list.filter(u => u.id !== action.payload);
      });
  },
});

export default usersSlice.reducer;
